import {SvgIcon, SvgIconProps} from "@material-ui/core";
import * as React from 'react';

class SwapIcon extends React.Component<SvgIconProps> {
    public render() {
        return (
            <SvgIcon {...this.props} style={{fill: 'none'}} fill="none" stroke="none">
                <path d="M1 12.1292C1 12.1292 1.17791 5.6478 7.04181 5.47923H17.9142" stroke="white" strokeWidth="2"
                      strokeMiterlimit="10"/>
                <path d="M20 10.2292C20 10.2292 19.8221 16.7107 13.9582 16.8792L3.08583 16.8792" stroke="white"
                      strokeWidth="2" strokeMiterlimit="10"/>
                <path d="M13.5115 9.27925L18.1455 5.47925L13.5115 1.67924" stroke="white" strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7.48705 13.0792L2.85303 16.8792L7.48705 20.6792" stroke="white" strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round"/>
            </SvgIcon>
        );
    }
}

export default SwapIcon;



// WEBPACK FOOTER //
// ./src/components/svg/swapIcon.tsx